import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'
import moment from 'moment'

const ReportsServiceContext = createContext(undefined)

const ReportsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={ReportsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        listTradePnlOrganizationMetas: async (query) => {
          const {data} = await axios.get(
            `/api/v1/reporting/reports/trade_pnl/organization_metas${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        updateTradePnlOrganizationMeta: async (id, payload) => {
          const {data} = await axios.put(`/api/v1/reporting/reports/trade_pnl/organization_metas/${id}`, payload)
          return data
        },
        createTradePnl: async (query) => {
          // TODO stevo: this should be a POST
          const {data} = await axios.get(
            `/api/v1/reporting/reports/trade_pnl${qs.stringify(query, {
              addQueryPrefix: true
            })}`,
            {
              responseType: 'blob'
            }
          )
          const href = window.URL.createObjectURL(data)
          const link = document.createElement('a')
          link.href = href
          link.setAttribute('download', `trade_pnl (${moment().format('YYYY-MM-DD')}).xlsx`) //or any other extension
          document.body.appendChild(link)
          link.click()
          return data
        },
        createSemCmeCtr: async (query) => {
          // TODO stevo: this should be a POST
          const {data} = await axios.get(
            `/api/v1/reporting/reports/sem_cme_ctr_report${qs.stringify(query, {
              addQueryPrefix: true
            })}`,
            {
              responseType: 'blob'
            }
          )
          const href = window.URL.createObjectURL(data)
          const link = document.createElement('a')
          link.href = href
          link.setAttribute('download', `cme_ctr_report-${moment().format('YYYY-MM-DD')}.csv`) //or any other extension
          document.body.appendChild(link)
          link.click()
          return data
        },
        getOtcTradePnl: async (id) => {
          const {data} = await axios.get(`/api/v1/reporting/trade_pnls/otc/${id}`)
          return data
        },
        getSemTradePnl: async (id) => {
          const {data} = await axios.get(`/api/v1/reporting/trade_pnls/sem/${id}`)
          return data
        },
        updateOtcTradePnl: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/reporting/trade_pnls/otc/${id}`, payload)
          return data
        },
        updateSemTradePnl: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/reporting/trade_pnls/sem/${id}`, payload)
          return data
        },
        getTradePnlGraph: async (query) => {
          const {data} = await axios.get(
            `/api/v1/reporting/graphs/trade_pnl${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

ReportsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useReportsService = () => {
  const context = useContext(ReportsServiceContext)
  if (context === undefined) {
    throw new Error('ReportsServiceContext was not provided. Make sure your component is a child of the ReportsServiceProvider.')
  }
  return context
}
const useTradePnlOrganizationMetasQuery = ({query, ...otherProps}) => {
  const reportsService = useReportsService()
  return useSimpleQuery({
    queryKey: `trade_pnl_organization_metas-list-${JSON.stringify(query)}`,
    queryFn: async () => reportsService.listTradePnlOrganizationMetas(query),
    ...otherProps
  })
}

const useTradePnlGraphQuery = ({query, ...otherProps}) => {
  const reportsService = useReportsService()
  return useSimpleQuery({
    queryKey: `trade_pnl_graphs-get-${JSON.stringify(query)}`,
    queryFn: async () => reportsService.getTradePnlGraph(query),
    ...otherProps
  })
}

export {ReportsServiceProvider, useReportsService, useTradePnlOrganizationMetasQuery, useTradePnlGraphQuery}
